/**
 * Quién presta el servicio.
 *
 * Ni los Términos ni el contrato lo identificaban: decían "FacturaPremium" y "Factura SV Premium
 * DTE", que son nombres comerciales. Sin persona, NIT y domicilio no queda claro a quién obliga
 * el acuerdo ni a quién reclamarle.
 */
export const PRESTADOR = {
    nombreComercial: "Factura Premium DTE",
    razonSocial: "Wilfredo Alexander Melgar López",
    nit: "013628532",
    nrc: "968811",
    domicilio: "San Salvador, El Salvador",
    /// Direccion publica para comunicaciones sobre los Terminos. Tiene que ser un buzon que
    /// alguien LEA: es la unica via que el contrato le da al cliente para un reclamo o un aviso
    /// de terminacion.
    ///
    /// Era una casilla de gmail.com porque el dominio **no recibia correo**: no tenia registros MX
    /// y todo lo que llegaba se perdia en silencio. Se corrigio el 10 de septiembre de 2026 con
    /// Email Routing de Cloudflare, comprobado enviando desde Outlook y Yahoo.
    ///
    /// `notificaciones@` sigue siendo solo el REMITENTE de los correos automaticos. El contacto
    /// que se publica es `soporte@`: un cliente que reclama no le escribe a una casilla que se
    /// llama "notificaciones".
    correo: "soporte@facturapremium.com",
    telefono: "+503 7976-3213",
} as const;

/**
 * Identificación para membretes y encabezados: nombre comercial y NIT.
 *
 * El NIT identifica de forma inequívoca a la persona natural, así que esto basta para saber a
 * quién obliga el documento sin encabezarlo con un nombre propio. El nombre legal completo
 * aparece una vez, en la sección "Prestador del Servicio" de los Términos, que existe justamente
 * para eso.
 *
 * Plataformas como Anthropic o Google no muestran ningún nombre de persona porque la parte es una
 * sociedad. Con una persona natural no hay otra parte que ella; lo que se puede hacer es
 * encabezar con la marca y dejar la identificación legal donde corresponde.
 */
export function identificacionPrestador(): string {
    return `${PRESTADOR.nombreComercial} — NIT ${PRESTADOR.nit} · NRC ${PRESTADOR.nrc} · ${PRESTADOR.domicilio}`;
}
